<template>
  <DialogDef2 :show="true" :label="'新增專案'" @close="$emit('close')">
    <div class="addnewDialog">
      <div class="field">
        <div>專案名稱</div>
        <Input :defaultValue="projectName" @input="projectName=$event"
        :center="true" :style="{width: '100%', height: '50px'}"/>
      </div>
      <div class="field">
        <div>專案ID</div>
        <div>
          <Input :defaultValue="projectId" @input="projectId=$event"
          :center="true" :style="{width: '100%', height: '50px'}"/>
          <div class="error" v-if="errorId" v-html="errorId"></div>
        </div>
      </div>
      <div class="field">
        <div>適用商店</div>
        <RT :options="restaurants" :style="{marginInline: 'auto', justifyContent: 'center'}"
        :defaultValue="store" @input="store=$event"></RT>
      </div>
      <BtnsS :style="{marginTop: '20px'}" @cancel="$emit('close')" @save="save"/>
    </div>
  </DialogDef2>
</template>

<script>
import { mapState } from 'vuex'
import Input from '../../../components/input/normal.vue'
import { getapi, putapi } from '../../../store/fetch'
export default {
  components: { Input },
  data () {
    return {
      projectId: null,
      projectName: null,
      store: null,
      errorId: null
    }
  },
  computed: {
    ...mapState({
      restaurants: 'restaurants',
      defaultStore: 'defaultStore'
    })
  },
  watch: {
    async projectId () {
      if (this.projectId) {
        this.errorId = await getapi(`projects/check/ID/${this.projectId}`, {}, false)
      } else {
        this.errorId = null
      }
    }
  },
  mounted () {
    this.store = this.defaultStore || this.restaurants[0]
  },
  methods: {
    async save () {
      if (this.errorId) {
        return false
      }
      if (!this.projectName || !this.projectId || !this.store) {
        console.log('[save]', '缺資料')
        return false
      }
      const r = await putapi('projects', { projectName: this.projectName, projectId: this.projectId, store: this.store })
      if (r) {
        this.$router.push({ name: 'restProjectSingle', params: { id: r._id }, query: { page: '基本設定' } })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.addnewDialog {
  width: 600px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  padding: 40px 60px;
  gap: 20px;
  .field {
    display: flex;
    flex-direction: column;
    font-size: 18px;
    gap: 10px;
    .error {
      color: var(--highlight);
    }
  }
}
</style>
